import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePickPackSettingsMobileConfiguration = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePickPackSettingsMobileConfiguration);
};
